import React from 'react';
import { Link } from 'react-router-dom';
import LeadForm from './LeadForm';
import ProductImage from './ProductImage';
import { products } from './productData';
import { whatsappUrl } from './WhatsAppButton';

const benefitStrip = ['Improved Milk Yield', 'Better Digestion', 'Stronger Immunity', 'Better Feed Efficiency', 'Livestock Wellness'];

const trustItems = [
  ['Scientifically Formulated', 'Advanced nutritional solutions engineered for optimal cattle and livestock performance.'],
  ['Premium Ingredients', 'Carefully formulated minerals, vitamins, digestive enhancers, and performance nutrients for practical farm productivity.'],
  ['Quality Assured', 'Professional product presentation and repeatable supply workflows for trade confidence.'],
  ['Consistent Supply', 'Practical packaging and dependable supply solutions tailored for livestock nutrition programs.'],
  ['Distributor Support', 'Product guidance, technical support, and responsive customer coordination.'],
  ['Bulk Orders Available', 'Bulk supply options available for farms, retailers, and commercial livestock operations.']
];

const productHighlights = products.slice(0, 3);

function Home() {
  return (
    <>
      <div className="section hero-section reveal">
        <div className="content hero-grid">
          <div className="hero-copy">
            <p className="eyebrow">Premium cattle feed supplements · India</p>
            <h1>Advanced Animal Nutrition Solutions for Healthier &amp; More Productive Livestock</h1>
            <p className="hero-lead">
              Premium cattle feed supplements scientifically formulated to support milk yield, digestion, immunity, and overall livestock performance.
            </p>
            <div className="cta-group">
              <Link to="/products" className="btn primary">Explore Products</Link>
              <Link to="/contact" className="btn secondary">Become a Distributor</Link>
              <a href={whatsappUrl} target="_blank" rel="noreferrer" className="btn gold">WhatsApp Inquiry</a>
            </div>
            <div className="hero-meta" aria-label="Business highlights">
              <span>GST Registered</span>
              <span>Bulk Supply</span>
              <span>Dealer Support</span>
            </div>
          </div>

          <div className="hero-visual" aria-label="Zyvora product and dairy farm visual">
            <img
              src="https://images.unsplash.com/photo-1527153857715-3908f2bae5e8?auto=format&fit=crop&w=1200&q=82"
              alt="Dairy cattle standing in an agricultural field"
              className="hero-image hero-image-main"
            />
            <div className="hero-product-rack" aria-label="Featured cattle feed supplement products">
              {productHighlights.map((product) => (
                <article className="hero-product" key={product.slug}>
                  <ProductImage product={product} variant="hero" />
                  <div>
                    <strong>{product.name}</strong>
                    <span>{product.category}</span>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </div>
      </div>

      <section className="benefit-strip" aria-label="Product outcomes">
        <div className="content benefit-strip-inner">
          {benefitStrip.map((benefit) => <span key={benefit}>✓ {benefit}</span>)}
        </div>
      </section>

      <section className="section compact-section trust-section reveal" aria-labelledby="trust-heading">
        <div className="content">
          <div className="section-heading-row practical-heading">
            <div>
              <p className="eyebrow">Business trust</p>
              <h2 id="trust-heading">Why Dairy Businesses Trust Zyvora</h2>
            </div>
            <p>Zyvora Life Sciences 9 supports farmers, dealers, and distributors with clear product categories, practical benefits, and supply-ready livestock nutrition solutions.</p>
          </div>
          <div className="trust-grid-commercial">
            {trustItems.map(([title, text]) => (
              <article className="trust-tile" key={title}>
                <h3>{title}</h3>
                <p>{text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section benefits-section reveal" aria-labelledby="benefits-heading">
        <div className="content commercial-split">
          <div>
            <p className="eyebrow">Product applications</p>
            <h2 id="benefits-heading">Nutrition support for everyday Livestock performance challenges.</h2>
            <p>Zyvora products range supports key livestock nutrition areas including rumen health, mineral supplementation, lactation support, recovery care, and vitamin balance.</p>
            <Link to="/products" className="btn secondary">View Product Range</Link>
          </div>
          <div className="application-list">
            {['Mineral mixture for productivity and fertility support', 'Rumen and digestion support for feed utilization', 'Vitamin support for lactation and seasonal stress', 'Oral gel formats for rapid field administration'].map((item) => (
              <article key={item}><span>•</span><p>{item}</p></article>
            ))}
          </div>
        </div>
      </section>

      <section className="section field-section reveal" aria-labelledby="field-heading">
        <div className="content field-grid">
          <div className="field-image-wrap">
            <img src="https://images.unsplash.com/photo-1500595046743-cd271d694d30?auto=format&fit=crop&w=1100&q=82" alt="Cattle grazing on a dairy farm" />
          </div>
          <div className="field-copy">
            <p className="eyebrow">Agricultural professionalism</p>
            <h2 id="field-heading">Built for farm counters, dairy advisors, and distributor networks.</h2>
            <p>Clear packaging, practical product literature, and responsive enquiry handling help trade partners present Zyvora products with confidence in local and bulk supply conversations.</p>
          </div>
        </div>
      </section>

      <section className="section dealer-section reveal" aria-labelledby="dealer-heading">
        <div className="content dealer-panel">
          <div>
            <p className="eyebrow">Dealer & distributor network</p>
            <h2 id="dealer-heading">Become a distributor for Zyvora livestock nutrition products.</h2>
            <p>Share your territory, business profile, and product interest. Our team will respond with literature, supply information, and dealership next steps.</p>
            <ul className="dealer-list">
              <li>Bulk product availability</li>
              <li>Dealer literature and catalogue support</li>
              <li>Responsive WhatsApp coordination</li>
            </ul>
          </div>
          <LeadForm formType="Distributor Inquiry" submitLabel="Request distributor call" compact />
        </div>
      </section>
    </>
  );
}

export default Home;
